import { AddUserRequest, UpdateAnagraficaRequest } from "interfaces";
import axiosInstance from "utils/AxiosInterceptor";

export const getAllUsers = async (...args: any) => {
  let url = `api/users/get-users?`;

  args.forEach((x: any) => {
    if (x) {
      for (const [key, value] of Object.entries(x)) {
        if (value !== null && value !== "") url = url + `&${key}=${value}`;
      }
    }
  });

  return axiosInstance.get(url);
};

export const addNewUser = async (payload: AddUserRequest) => {
  return axiosInstance.post("api/users/add", payload);
};

export const updateUser = async (payload: UpdateAnagraficaRequest) => {
  return axiosInstance.put("api/users/update", payload);
};

export const deleteUser = async (userId: string) => {
  return axiosInstance.delete(`api/users/delete?userId=${userId}`);
};
